import _ from "lodash";
import {displayFunctions} from "./StoreTotalsDataSelections";

export function buildOutlierIndex(averages, selectedData) {
    const {valueKey, countKey, averageKey, diffKey} = displayFunctions[selectedData];
    const averagesByStore = new Map();
    averages.forEach(average => {
        if (!averagesByStore.has(average.storeId)) {
            averagesByStore.set(average.storeId, average);
        }
    });
    const outliersByCleansed = new WeakMap();

    const averageFor = (storeId) => averagesByStore.get(storeId);

    const outlierFor = (storeId, cleansed) => {
        if (!outliersByCleansed.has(cleansed)) {
            const average = averagesByStore.get(storeId)?.[averageKey];
            const value = cleansed[valueKey];
            const diff = _.isNil(average) || _.isNil(value) ? undefined : Math.abs(Math.abs(value - average) / average) * 100;
            outliersByCleansed.set(cleansed, Number.isFinite(diff) ? {
                storeId,
                weekEndDate: cleansed.date,
                [countKey]: value,
                [averageKey]: average,
                [diffKey]: diff
            } : undefined);
        }
        return outliersByCleansed.get(cleansed);
    };

    return {averageFor, outlierFor};
}
